import { ChangeDetectorRef, Directive, Input } from '@angular/core';
import { ConfigResource } from '@df/catalog/config/config.resource';
import { App } from '@df/core/app';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';
import { CMS_CONFIG_V12_RETAIL_FINANCE, IICmsConfigV12RetailFinanceData } from '../v12-retail-finance.cms-config';
@Directive()
// tslint:disable-next-line: directive-class-suffix
export abstract class AbstractFinanceFromComponent {
    @Input()
    amount?: number;
    private config?: ICmsConfig<IICmsConfigV12RetailFinanceData>;
    constructor(private app: App, private configResource: ConfigResource, protected changeDetectionRef: ChangeDetectorRef) { }
    ngOnInit(): void {
        this.configResource.loadModelByUrl(CMS_CONFIG_V12_RETAIL_FINANCE).then(() => {
            this.config = this.configResource.getModelByUrl(CMS_CONFIG_V12_RETAIL_FINANCE) as any as ICmsConfig<IICmsConfigV12RetailFinanceData>;
            this.changeDetectionRef.detectChanges();
        });
    }
    get financeFrom(): number | undefined {
        if (!this.amount) {
            return undefined;
        }

        const configContent = this.config?.data?.content;

        if (!configContent) {
            return undefined;
        }
        const { valueFinanceMonth, valueFinancePercent, valueDepositPercent } = configContent;

        const defaultOption = this.app?.data?.vfinance?.v12pack?.find(i => {
            const v12package = i.package;
            if (!v12package) return undefined;
            const packageParts = v12package.split('/');
            const months = parseInt(packageParts[2], 10);
            const apr = parseFloat(packageParts[4]);
            return months === valueFinanceMonth && apr === valueFinancePercent;
        });

        if (defaultOption?.package) {
            const interest = parseFloat(defaultOption.package.split('/')[3]) || 0;
            const depositAmount = (this.amount / 100) * valueDepositPercent;
            const loanAmount = (this.amount * 100 - depositAmount * 100) / 100;

            return Math.round(loanAmount * interest * 100) / 100;
        } else {
            return undefined;
        }
    }
}
